// extracted by mini-css-extract-plugin
export default {"container":"RouteWrapper_container__HpSQg"};